module.exports = __webpack_public_path__ + "cf63a15db133e43b97f8f1c55d99e5c9.MP3";